<template lang="html">
  <div class="pagination__wrapper">
    <div class="pagination__label">
      <span v-if="totalItems >0"> Mostrando {{ skip + 1 }} a {{ take }} de {{totalItems}} registros</span>
      <span v-else> Nenhum resultado encontrado</span>
    </div>
    <paginate
      v-model="page"
      :pageCount="pageCount"
      :prevText="prev"
      :nextText="next"
      :click-handler="clickCallback"
      :containerClass="'pagination'">
    </paginate>
  </div>
</template>

<script>
import Events from '_utils/events';
import Paginate from 'vuejs-paginate';

export default {
  name: 'pagination',
  components: {
    Paginate,
  },
  props: {
    totalItems: {
      type: Number,
    },
    prev: {
      type: String,
      default: 'Anterior',
    },
    next: {
      type: String,
      default: 'Proximo',
    },
    eventName: {
      type: String,
      default: 'update:pagination',
    },
    pagination: {
      type: Object,
      default() {
        return {
          skip: 0,
          take: 10,
          page: 1,
        };
      },
    },
  },
  data() {
    return {
      search: '',
      timer: null,
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.totalItems / this.pagination.take);
    },
    skip() {
      return (this.pagination.page - 1) * this.pagination.take;
    },
    take() {
      if ((this.pagination.take + this.pagination.skip) > this.totalItems) {
        return this.totalItems;
      }
      return (this.pagination.take + this.pagination.skip);
    },
    page: {
      get() {
        return parseInt(this.pagination.page, Number);
      },
      set(value) {
        this.pagination.page = value;
        this.pagination.skip = this.skip;
      },
    },
  },
  watch: {
    pagination: {
      handler(value) {
        if (JSON.stringify(value.search) !== JSON.stringify(this.search)) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.search = value.search;
            if (this.pagination.page !== 1) {
              this.pagination.page = 1;
              this.pagination.skip = 0;
            } else {
              Events.$emit(this.eventName, this.pagination);
            }
          }, 800);
        } else {
          Events.$emit(this.eventName, this.pagination);
        }
      },
      deep: true,
    },
  },
  methods: {
    clickCallback(pageNum) {
      this.page = pageNum;
      // Events.$emit(this.eventName, this.pagination);
    },
  },
  beforeCreate() {},
  mounted() {},
};
</script>

<style lang="scss">
@import '~_scss/overrides';

.pagination__wrapper {
  display: flex;
  justify-content: space-between;
  padding: 1rem 1rem 0;
  border-top: 1px solid #ddd;
  align-items: center;
  .pagination {
    display: flex;
    margin-bottom: 0;
    li {
      border: 1px solid $primary;
      margin-right: -1px;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
      &.disabled {
        // background: #d3d3d3;
        border: 1px solid #aaaaaa;
        a {
          color: #777;
          cursor: not-allowed;
        }
      }
      &.active {
        background: $primary;
        a {
          color: $card-cap-bg;
          cursor: default;
        }
      }
      a {
        padding: 6px 12px;
        display: block;
      }
    }
  }
}
</style>
